import React, { useEffect } from 'react'
import { Outlet, useParams } from 'react-router'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ProductionUnitAction from 'productionUnit/actions/ProductionUnitAction'
import HomeAction from 'home/actions/HomeAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import UnitAction from 'referencial/components/unit/actions/UnitAction'
import CityAction from 'referencial/components/city/actions/CityAction'
import MaterielAction from 'materiel/actions/MaterielAction'
import AdministrationAction from 'administration/actions/AdministrationAction'
import StationAction from 'station/actions/StationAction'
import { ProductionUnitActionConstant } from 'productionUnit/reducers/ProductionUnitReducer'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import { H_MAT_MODULE, H_UNITS_CONFORMITY, H_UNITS_DASHBOARD, H_UNITS_DESCRIPTION, H_UNITS_DOCUMENTS, H_UNITS_EVENTS, H_UNITS_GRAPHIC, H_UNITS_SUIVIPC } from 'account/constants/AccessRulesConstants'
import { links } from 'station/constants/LinksConstants'
import i18n from 'simple-react-i18n'
import BoundaryError from 'log/components/BoundaryError'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import { STATION_TYPE_CONSTANT, STATION_TYPE_NAME } from 'station/constants/StationConstants'
import { isNil } from 'lodash'
import { Box } from '@mui/material'

const ProductionUnitApp = ({
}) => {
    const dispatch = useDispatch()

    const { id } = useParams()

    const {
        productionUnit,
        prodUnitLinks,
    } = useSelector(store => ({
        productionUnit: store.ProductionUnitReducer.productionUnit,
        prodUnitLinks: store.ProductionUnitReducer.prodUnitLinks,
    }), shallowEqual)

    useEffect(() => {
        dispatch(HomeAction.setBackPath(`/${STATION_TYPE_NAME.productionUnit}`))
        dispatch(HomeAction.setHelpLink('', ''))
        dispatch(ContributorAction.fetchContributors())
        dispatch(UnitAction.fetchUnits())
        dispatch(CityAction.fetchCities())
        dispatch(MaterielAction.fetchMaterielTypes())
        dispatch(AdministrationAction.fetchApplicationSettings())
        dispatch(ProductionUnitAction.fetchProductionUnits())
    }, [])

    useEffect(() => {
        dispatch(ProductionUnitAction.fetchProductionUnit(id))
        dispatch(ProductionUnitAction.fetchProductionUnitLinks(id))
        dispatch(ProductionUnitAction.fetchProductionUnitEvents(id))
        return () => {
            dispatch(StationAction.resetAssociatedSites())
            dispatch(ProductionUnitActionConstant.resetProductionUnit())
        }
    }, [id])

    useEffect(() => {
        if (isNil(productionUnit.code)) return
        dispatch(StationAction.fetchAssociatedSites(productionUnit.code, STATION_TYPE_CONSTANT.productionUnit))

        if (productionUnit.code?.replace(' ', '') === '') return
        dispatch(StationAction.fetchPictures(productionUnit.code, STATION_TYPE_NAME.productionUnit))
        dispatch(StationAction.fetchFiles(productionUnit.code, STATION_TYPE_NAME.productionUnit))
    }, [productionUnit])

    const getLink = (linkName) => {
        if (linkName !== 'materiel' || componentHasHabilitations(H_MAT_MODULE)) {
            return {
                ...links[linkName],
                href: `/station/${STATION_TYPE_NAME.productionUnit}/${id}/${linkName}`,
                name: i18n[links[linkName].i18n],
                'data-cy': linkName,
            }
        }
        return null
    }

    const isQualitoAssociated = prodUnitLinks.some(site => site.stationLinkedType === STATION_TYPE_CONSTANT.quality)
    const qualityFeatures = isQualitoAssociated ? [
        { habilitation: H_UNITS_GRAPHIC, link: 'graphic' },
        { habilitation: H_UNITS_SUIVIPC, link: 'pcMonitoring' },
        { habilitation: H_UNITS_CONFORMITY, link: 'conformityOverview' },
    ] : []
    const navBarLinks = [
        { habilitation: H_UNITS_DASHBOARD, link: 'dashboard' },
        { habilitation: H_UNITS_DESCRIPTION, link: 'description' },
        { habilitation: H_UNITS_DASHBOARD, link: 'map' },
        { habilitation: H_UNITS_EVENTS, link: 'event' },
        { habilitation: H_UNITS_DOCUMENTS, link: 'picture' },
        ...qualityFeatures,
    ] .filter(l => componentHasHabilitations(l.habilitation))
        .map(l => getLink(l.link))
        .filter(l => !!l)

    return (
        <Box>
            <FixedSlideNav links={navBarLinks} />
            <Box className='content-page no-padding fullscreen'>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

ProductionUnitApp.propTypes = {
}

export default ProductionUnitApp
